import { buttonVariants } from "@/components/ui/button/button";
import { Link, useLoaderData } from "@tanstack/react-router";
import { Building2 } from "lucide-react";

const hasEin = (einNumber: string | null): boolean =>
	!!einNumber && einNumber.replace(/\D/g, "").length > 0;

const AddEinNoticeCard = () => {
	const { user } = useLoaderData({ from: "/main" });

	const records = user.guest_business_details ?? [];
	// Only nudge once the business profile exists but is missing an EIN. The EIN is
	// optional, but it's required to unlock Level 3 (L3) processing data.
	const recordMissingEin = records.find((record) => !hasEin(record.ein_number));

	if (records.length === 0 || !recordMissingEin) {
		return null;
	}

	return (
		<div className="mb-6 flex flex-col rounded-2xl border border-gray-200 bg-primary-50/50 p-5">
			<div className="flex gap-4">
				<div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full bg-primary-100">
					<Building2 className="size-5 text-primary-600" />
				</div>
				<div className="min-w-0 flex-1">
					<h3 className="font-semibold text-textDark">
						Finish your business profile
					</h3>
					<p className="mt-1 text-sm text-textDark">
						Add your EIN to complete your business profile.
					</p>
				</div>
			</div>
			<Link
				to="/main/setting/business-details/edit/$businessDetailId"
				params={{ businessDetailId: String(recordMissingEin.id) }}
				className={buttonVariants({
					variant: "secondary",
					size: "lg",
					className: "mt-4 w-full",
				})}
			>
				Add your EIN
			</Link>
		</div>
	);
};

export default AddEinNoticeCard;
